import React, { useEffect, useRef, useState } from "react";

function Collapse({ isOpen, className = "", children, style }) {
  const ref = useRef(null);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const measure = () => {
      // 자식 실제 높이 측정
      const contentHeight = el.scrollHeight;
      setMaxHeight(isOpen ? contentHeight : 0);
    };

    measure();

    // 콘텐츠 변화에도 반응
    const ro = new ResizeObserver(() => measure());
    ro.observe(el);
    return () => ro.disconnect();
  }, [isOpen, children]);

  return (
    <div
      ref={ref}
      className={className}
      style={{
        ...style,
        maxHeight,
        opacity: isOpen ? 1 : 0,
        transform: isOpen ? "translateY(0)" : "translateY(-4px)",
      }}
      aria-hidden={!isOpen}
    >
      {children}
    </div>
  );
}

export default Collapse;


